import Vue from "vue";

/**
 * Class Profile Service
 */
export default class ProfileService extends Vue {
    private customActions = {
        getStatus: { method: 'GET', url: 'auth/user-status' },
        getPlatformsProfile: { method: 'GET', url: 'auth/get-platforms-profile/{user_id}' },
        getPlatform: { method: 'GET', url: 'auth/get-platforms/status/platform_active' },
        getPhonesZapguru: { method: 'GET', url: 'auth/zapguru/phones' }
    };

    private resource: any = this.$resource('auth/profile', {}, this.customActions);

    public getProfile() {
        return this.resource.get();
    }
  
    public getStatus() {       
      return this.resource.getStatus();
    }
  
    // get platform linked users
    public getPlatform() {
        return this.resource.getPlatform({});
    }

    // get phones zapguru
    public getPhonesZapguru() {
        return this.resource.getPhonesZapguru({});
    }

    // get platforms profile by user
    public getPlatformsProfile(user_id) {
        if (!user_id)
            return

        return this.resource.getPlatformsProfile({ user_id });
    }
}